import { Action } from "redux";
import { ThunkAction } from "../types/index.js";
import { copiedModuleClipboard } from "../utils/utils.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["LOGOUT_USER"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type LogoutUser = ActionBase<"LOGOUT_USER">;

export type UserAction = LogoutUser;

export const isUserAction = (action: Action): action is UserAction =>
  isActionType(action, ActionTypeKeys);

export const logoutUser = (): ThunkAction<void> => (dispatch) => {
  copiedModuleClipboard.clear();
  dispatch<LogoutUser>({ type: "LOGOUT_USER" });
};
